import { useCallback } from 'react'
import { getYaNative } from '@yanolja-rnd/ya-native'
import { isNative } from '~/app/utils/typeguards'
import conf from '~/app/conf'

export const useNavigation = () => {
  /**
   * 홈 버튼 클릭 핸들러
   * 네이티브 앱에서는 deepLink, 웹에서는 location.href로 이동
   */
  const onHomeClick = useCallback(() => {
    const yaNative = getYaNative()
    if (isNative(yaNative)) {
      yaNative.deepLink({ link: conf.app.home.url })
    } else {
      window.location.href = conf.web.url
    }
  }, [])

  /**
   * 뒤로가기 버튼 클릭 핸들러
   * 네이티브 앱에서는 dismiss, 웹에서는 history.back() 실행
   */
  const onBackClick = useCallback(() => {
    const yaNative = getYaNative()
    if (isNative(yaNative)) {
      yaNative.dismiss()
    } else {
      history.back()
    }
  }, [])

  /**
   * 마이페이지 버튼 클릭 핸들러
   * 네이티브 앱에서는 deepLink, 웹에서는 location.href로 이동
   */
  const onMyPageClick = useCallback(() => {
    const yaNative = getYaNative()
    if (isNative(yaNative)) {
      yaNative.deepLink({ link: conf.app.mypage.url })
    } else {
      window.location.href = `${conf.web.url}/mypage`
    }
  }, [])

  /**
   * 위시리스트 버튼 클릭 핸들러
   * 네이티브 앱에서는 웹뷰로, 웹에서는 location.href로 이동
   */
  const onWishlistClick = useCallback(() => {
    const yaNative = getYaNative()
    if (isNative(yaNative)) {
      yaNative.wv({
        url: `${conf.web.url}/wishlist`,
      })
    } else {
      window.location.href = `${conf.web.url}/wishlist`
    }
  }, [])

  /**
   * 장바구니 버튼 클릭 핸들러
   * 현재 페이지가 장바구니면 새로고침, 아니면 장바구니로 이동
   */
  const onCartClick = useCallback(() => {
    if (window.location.pathname === '/cart') {
      window.location.reload()
      return
    }

    const yaNative = getYaNative()
    if (isNative(yaNative)) {
      yaNative.wv({
        url: `${conf.web.url}/cart`,
      })
    } else {
      window.location.href = `/cart`
    }
  }, [])

  /**
   * 최근 본 상품 버튼 클릭 핸들러
   * 네이티브 앱에서는 웹뷰로, 웹에서는 location.href로 이동
   */
  const onRecentProductClick = useCallback(() => {
    const yaNative = getYaNative()
    if (isNative(yaNative)) {
      yaNative.wv({
        url: `${conf.web.url}/recent-product/list?target=HOME`,
      })
    } else {
      window.location.href = `${conf.web.url}/recent-product/list?target=HOME`
    }
  }, [])

  return {
    onHomeClick,
    onBackClick,
    onMyPageClick,
    onWishlistClick,
    onCartClick,
    onRecentProductClick,
  }
}
